import React from 'react';
const TRUST_POINTS = ['Free In-Home Estimates', 'Broken Window Repair', 'Foggy Double-Pane Glass', 'Glass-Only Replacement', 'Door Glass Replacement', 'Custom Mirrors & Shower Glass', 'Warranty-Backed Work', 'Howell, Ann Arbor & Novi'];
export function TrustBar() {
  return <section aria-label="Service highlights" className="bg-navy-900 py-6 px-4 sm:px-6 lg:px-8 border-t border-navy-800" data-id="element-286">
      <div className="max-w-7xl mx-auto" data-id="element-287">
        <ul className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-288">
          {TRUST_POINTS.map((point, idx) => <li key={idx} className="inline-flex items-center px-3 py-1.5 rounded-full bg-navy-800 text-slate-200 text-sm font-medium border border-navy-700 whitespace-nowrap" data-id="element-289">
              {point}
            </li>)}
        </ul>
      </div>
    </section>;
}